import * as i0 from "@angular/core";
var AttendanceService = /** @class */ (function () {
    function AttendanceService() {
    }
    Object.defineProperty(AttendanceService.prototype, "setHeaderStatus", {
        set: function (val) {
            this.headerStatus = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AttendanceService.prototype, "getHeaderStatus", {
        get: function () {
            return this.headerStatus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AttendanceService.prototype, "setSideMenuStatus", {
        set: function (val) {
            this.sideMenuStatus = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AttendanceService.prototype, "getSideMenuStatus", {
        get: function () {
            return this.sideMenuStatus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AttendanceService.prototype, "setIsMobile", {
        set: function (val) {
            this.isMobile = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AttendanceService.prototype, "getIsMobile", {
        get: function () {
            return this.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    AttendanceService.prototype.checkSize = function () {
        var _this = this;
        setTimeout(function () {
            _this.screenWidth = window.innerWidth;
            _this.screenHeight = window.innerHeight;
            if (_this.screenWidth < 768) {
                _this.setIsMobile = true;
                _this.setSideMenuStatus = false;
            }
            else {
                _this.setIsMobile = false;
                _this.setSideMenuStatus = true;
            }
        }, 1);
    };
    AttendanceService.ngInjectableDef = i0.defineInjectable({ factory: function AttendanceService_Factory() { return new AttendanceService(); }, token: AttendanceService, providedIn: "root" });
    return AttendanceService;
}());
export { AttendanceService };
